export function reload(): void {
    window.location.href = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
}
